import React, { PureComponent } from 'react';

class Commodities extends PureComponent {
  renderCommodities = () => <div>Hi from Commodities</div>;

  render() {
    return (
      <div>
        {this.renderCommodities()}
      </div>
    );
  }
}

export default Commodities;

